var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChooseRight4Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8361_2321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16C3 8.26801 9.26801 2 17 2H29C36.732 2 43 8.26801 43 16V28C43 35.732 36.732 42 29 42H17C9.26801 42 3 35.732 3 28V16Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3332 23.6667C16.1755 23.6673 16.0209 23.623 15.8874 23.5392C15.7538 23.4554 15.6468 23.3354 15.5787 23.1931C15.5106 23.0509 15.4843 22.8922 15.5028 22.7356C15.5213 22.579 15.5839 22.4309 15.6832 22.3084L23.9332 13.8084C23.9951 13.737 24.0795 13.6887 24.1724 13.6715C24.2653 13.6543 24.3613 13.6692 24.4447 13.7138C24.528 13.7584 24.5937 13.83 24.631 13.9168C24.6683 14.0037 24.675 14.1006 24.6499 14.1917L23.0499 19.2084C23.0027 19.3347 22.9869 19.4705 23.0037 19.6042C23.0206 19.738 23.0696 19.8656 23.1467 19.9762C23.2237 20.0869 23.3264 20.1771 23.446 20.2394C23.5656 20.3016 23.6984 20.3338 23.8332 20.3334H29.6666C29.8243 20.3329 29.9789 20.3771 30.1124 20.4609C30.246 20.5447 30.3531 20.6648 30.4211 20.807C30.4892 20.9493 30.5155 21.1079 30.497 21.2645C30.4785 21.4211 30.4159 21.5693 30.3166 21.6917L22.0666 30.1917C22.0047 30.2632 21.9204 30.3114 21.8274 30.3286C21.7345 30.3458 21.6385 30.3309 21.5551 30.2863C21.4718 30.2417 21.4061 30.1701 21.3688 30.0833C21.3315 29.9965 21.3248 29.8995 21.3499 29.8084L22.9499 24.7917C22.9971 24.6655 23.0129 24.5296 22.9961 24.3959C22.9792 24.2621 22.9302 24.1345 22.8532 24.0239C22.7761 23.9132 22.6734 23.823 22.5538 23.7608C22.4343 23.6985 22.3014 23.6663 22.1666 23.6667H16.3332Z",
    stroke: "#9810FA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8361_2321",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8361_2321"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8361_2321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8361_2321",
    result: "effect2_dropShadow_8361_2321"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8361_2321",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseRight4Icon);
export default __webpack_public_path__ + "static/media/choose_right_4_icon.334599a6a3ff5970233c0190bda531a6.svg";
export { ForwardRef as ReactComponent };